import React from 'react';
import { CollapsibleSection } from '../common/CollapsibleSection';
import { GeneralParameters } from './GeneralParameters';
import { GeneralParameterDefinition } from '../../types';

interface GeneralParametersSectionProps {
  generalParameters: GeneralParameterDefinition[];
  generalValues: Record<string, any>;
  onGeneralParameterChange: (id: string, value: any) => void;
  disabled?: boolean;
}

/**
 * General parameters section component that contains general assumptions and controls
 */
export const GeneralParametersSection: React.FC<GeneralParametersSectionProps> = ({
  generalParameters,
  generalValues,
  onGeneralParameterChange,
  disabled = false
}) => {

  return (
    <CollapsibleSection
      title="General Assumptions"
      className="general-assumptions-section"
    >
      <div className="general-assumptions">
        <GeneralParameters
          parameters={generalParameters}
          values={generalValues}
          onChange={onGeneralParameterChange}
          disabled={disabled}
        />
      </div>
    </CollapsibleSection>
  );
};
